<template>
  <transition :name="isMobile ? 'fade-in-up' : 'fade-in-down'">
    <div
      class="modal"
      v-if="isVisible"
      ref="modal"
      @click.self="close"
    >
      <div class="modal-wrapper">
        <div class="modal-center">
          <div class="modal-container bg-cl-primary" ref="modal-content" :style="style">
            <header class="modal-header py20 px25 weight-100 bg-cl-light-blue cl-white" v-if="$slots.header">
              <span
                slot="close"
                class="modal-close h4"
                @click="close"
                data-testid="closeModalButton"
              >
                <span v-show="!isMobile">ZAMKNIJ</span><close-svg class="pl10" width="16px" height="100%" color="#ffffff" />
              </span>
              <slot name="header" />
            </header>
            <div class="modal-content pt20 pb20 px35" v-if="$slots.content">
              <slot name="content" />
            </div>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { MobileDetected } from './mobileDetected.ts'
import { mapMutations } from 'vuex'
import onEscapePress from '@vue-storefront/core/mixins/onEscapePress'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import CloseSvg from 'theme/components/theme/blocks/Icons/CloseSvg.vue'

export default {
  name: 'Modal',
  components: {
    CloseSvg
  },
  data () {
    return {
      isVisible: false
    }
  },
  methods: {
    onHide (name, state, params) {
      return name === this.name ? this.toggle(false) : false
    },
    onShow (name, state, params) {
      return name === this.name ? this.toggle(true) : false
    },
    onToggle (name, state, params) {
      if (name === this.name) {
        state = typeof state === 'undefined' ? !this.isVisible : state
        this.toggle(state)
      }
    },
    onEscapePress () {
      this.close()
    },
    ...mapMutations('ui', [
      'setOverlay'
    ]),
    toggle (state) {
      this.isVisible = state
      state ? this.setOverlay(state) : setTimeout(() => this.setOverlay(state), this.delay)
    },
    close () {
      this.toggle(false)
    }
  },
  watch: {
    isVisible (state) {
      if (state) {
        this.$nextTick(() => {
          disableBodyScroll(this.$refs['modal']);
        })
      } else {
        clearAllBodyScrollLocks();
      }
    }
  },
  beforeMount () {
    this.$bus.$on('modal-toggle', this.onToggle)
    this.$bus.$on('modal-show', this.onShow)
    this.$bus.$on('modal-hide', this.onHide)
  },
  beforeDestroy () {
    this.$bus.$off('modal-toggle', this.onToggle)
    this.$bus.$off('modal-show', this.onShow)
    this.$bus.$off('modal-hide', this.onHide)
  },
  mixins: [onEscapePress, MobileDetected],
  props: {
    name: {
      required: true,
      type: String
    },
    delay: {
      required: false,
      type: Number,
      default: 300
    },
    width: {
      type: Number,
      default: 0
    }
  },
  computed: {
    style () {
      return this.width ? `width: ${this.width}px` : false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
$z-index-modal: map-get($z-index, modal);

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: $z-index-modal;
  text-align: inherit;

  .modal-wrapper {
    display: table;
    height: 100%;
    width: 100%;
    table-layout: fixed;
    pointer-events: none;
  }

  .modal-center {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 900px;
    margin: 0 auto;
    max-width: 100%;
    max-height: 100%;
    z-index: $z-index-modal+1;
    pointer-events: auto;

    @media (max-width: 600px) {
      min-height: 100%;
      min-width: 100%;
      margin: 0;
    }
  }

  .modal-header {
    position: relative;

    > p {
        margin: 0;
    }

    @media (max-width: 600px) {
      padding: 25px 20px;
    }
  }

  .modal-content {
    max-height: 70vh;
    overflow-y: auto;
    @media (max-width: 767px) {
      max-height: 100%;
    }
    @media (max-width: 600px) {
      padding: 30px 20px;
    }
  }

  .modal-close {
    position: absolute;
    cursor: pointer;
    user-select: none;
    right: 25px;
    top: 18px;
    display: flex;
    align-items: center;
  }
}
</style>
